import { axiosProtected, axiosPublic, baseUrl } from '../config';
import Cookies from 'js-cookie';
import { getAppSource, getUserType } from '../helpers';
import axios from 'axios';

  export const updateMyFeedbackProtected = async (payload) => {
    try {

        const data = {
            "privateLabelUrl": Cookies.get("privateLabelUrl"),
            "ipAddress": Cookies.get('publicIp'),
            "browser": Cookies.get("browser"),
            "appSource": getAppSource(),
            "userType": getUserType(),
            ...payload
          }

      const res = await axiosProtected.post('Feedback/SubmitBorrowersFeedback', data);
      return res.data
    } catch (e) {    
      return null
    }
  }

  export const feedbackDisplay = async (loanNumber, type) => {
    try {

        const data = {
            "privateLabelUrl": Cookies.get("privateLabelUrl"),
            "ipAddress": Cookies.get('publicIp'),
            "browser": Cookies.get("browser"),
            "appSource": getAppSource(),
            "userType": getUserType(),
            "feedbackType": type,
            "userName": "",
            "accountNumber": loanNumber
          }

      const res = await axiosProtected.post('Feedback/Display', data);
      return res.data
    } catch (e) {    
      return null
    }
  }

  export const chatFeedbackSubmit = async (rating, comment, accountNumber, src) => {
    try {
        const data = {           
            "loanNumber": accountNumber,
            "feedbackRating": rating,
            "feedbackComment": comment,
            "feedbackType": "ChatFeedback#" + src,
            "privateLabelUrl": Cookies.get("privateLabelUrl"),
            "ipAddress": Cookies.get('publicIp'),
            "browser": Cookies.get("browser"),
            "appSource": getAppSource(),
            "userType": getUserType(),
            "userName": ""
          }

      const response = await axiosPublic.post('/OT/SubmitBorrowersFeedback', data);
      return response.data;
    } catch (e) {    
      return null
    }
  }

  export const quickPayFeedbackSubmit = async (payload) => {

    try {
        const data = {
            "privateLabelUrl": Cookies.get("privateLabelUrl"),
            "ipAddress": Cookies.get('publicIp'),
            "browser": Cookies.get("browser"),
            "appSource": getAppSource(),
            "userType": getUserType(),
            ...payload
          }

      const response = await axiosPublic.post('/OT/SubmitBorrowersFeedback', data);
      return response.data;
    } catch (e) {    
      return null
    }
  }

  export const quickPayFeedbackDisplay = async (loanNumber, type) => {
   
    try {
      const data = {
        "privateLabelUrl": Cookies.get("privateLabelUrl"),
        "ipAddress": Cookies.get('publicIp'),
        "browser": Cookies.get("browser"),
        "appSource": getAppSource(),
        "userType": getUserType(),
        "feedbackType": type,
        "userName": "",
        "accountNumber": loanNumber
      }

      const response = await axiosPublic.post('/OT/Display', data);
      return response.data;
    } catch (e) {
      return null
    }
  }
